import React, { useEffect, useState, Suspense } from 'react'
import { Box, CircularProgress, Grid } from '@material-ui/core'
import { useMonitoreo } from '../../../context/MonitoreoContext'
import StepWizard from 'react-step-wizard'
import { MonitoreoSeccion1 } from './MonitoreoSeccion1'
import { MonitoreoSeccion2 } from './MonitoreoSeccion2'
import { getFormReportAnswer } from '../../../services/MonitoreoYEvaluacion/get'
import { useFormMonitoringAndEvaluation } from '../../../context/MonitoringAndEvaluationContext'

export const MonitoreoYEvaluacion = ({ idForm, edit }) => {
  const [state] = useMonitoreo()
  const [loading, setLoading] = useState(true)
  const { setMonitoringAndEvaluationForm } = useFormMonitoringAndEvaluation()

  const getEditFormMonitoringEvaluation = async (idForm) => {
    try {
      const response = await getFormReportAnswer(idForm)
      if (response.Success) {
        setMonitoringAndEvaluationForm(response.Data)
        setLoading(false)
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (edit) {
      getEditFormMonitoringEvaluation(idForm)
    } else {
      setLoading(false)
    }
  }, [])

  return (
    <>
      {!loading ? (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <Grid
            container
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '36px' }}
          >
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 1
                  ? // step === 1
                    `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 1</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 2
                  ? // step === 1
                    `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 2</label>
            </Grid>
          </Grid>

          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '80%',
                  height: '80vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <StepWizard initialStep={1}>
              <MonitoreoSeccion1 edit={edit} />
              <MonitoreoSeccion2 edit={edit} />
            </StepWizard>
          </Suspense>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}
